export const counters = () => {
  const countersContainer = document.querySelector(".js-counters");

  if (!countersContainer) {
    return; // Exit the function if the container element wasn't found
  }

  const counterElements = countersContainer.querySelectorAll(".js-counter");

  counterElements.forEach((counterElement) => {
    const targetNumber = parseInt(
      counterElement.getAttribute("data-count"),
      10
    );

    if (isNaN(targetNumber)) {
      return; // Skip if the 'data-count' attribute is not a valid number
    }

    // Adjust duration based on the targetNumber
    const duration = calculateDuration(targetNumber);

    function calculateDuration(number) {
      // Example logic: If the number is 10, set duration to 200 milliseconds. If it's 100, set duration to 2000 milliseconds.
      return Math.min(Math.abs(number) * 75, 1500); // Adjust the multiplier as needed
    }

    function animateNumber() {
      var startNumber = 0;
      const increment = targetNumber / (duration / 16); // Assuming 60 frames per second

      function updateCounter() {
        startNumber < targetNumber
          ? (startNumber += increment)
          : (startNumber -= increment);

        counterElement.innerText = Math.round(startNumber);
        if (
          (startNumber < targetNumber &&
            startNumber + increment <= targetNumber) ||
          (startNumber > targetNumber &&
            startNumber - increment >= targetNumber)
        ) {
          requestAnimationFrame(updateCounter);
        } else {
          counterElement.innerText = targetNumber;
        }
      }

      updateCounter();
    }

    // Example usage
    animateNumber();
  });
};
